import { FC, ReactNode } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    children: ReactNode;
    text?: string; // only for storybook
    className?: string;
}

const Paragraph: FC<Props> = ({ children, text, className }) => {
    return <p className={cn('', className)}>{text ?? children}</p>;
};

export default Paragraph;
